import React from 'react'
import { Icon, Typography } from '@telavita-core/react-design-kit'
import { ReservationType } from '../../ProfessionalReservations'

import * as S from './styles'

interface ReservationEmptyStateProps {
  selectedTab: ReservationType
}

export const ReservationEmptyState: React.FC<ReservationEmptyStateProps> = ({
  selectedTab
}) => {
  return (
    <S.Container>
      <Icon name='NoReservation'/>
      {
        selectedTab === ReservationType.RECURRENT
          ? (
          <>
            <Typography variant='content2' customClassName='reservationEmptyStateTitle'>
              Nenhuma reserva criada
            </Typography>

            <S.TextWrapper>
              <Typography center variant='content3' inheritColor>
                Só você pode criar uma reserva, e isso deve ocorrer durante a consulta.
              </Typography>
              <Typography center variant='content3' inheritColor>
                Ao criar uma reserva para um paciente, o horário escolhido será agendado automaticamente, toda semana.
              </Typography>
              <Typography center variant='content3' inheritColor>
              Você também pode cancelar as reservas caso identifique que o paciente não utilizará mais o horário. Caso o próprio paciente cancele, o horário voltará a ficar disponível para outras pessoas.
              </Typography>
            </S.TextWrapper>
          </>
          )
          : (
          <>
            <Typography center variant='content2' customClassName='reservationEmptyStateTitle'>
              Nenhuma reserva avulsa criada
            </Typography>
            <Typography center variant='content3' customClassName='reservationEmptyStateText'>
              As avulsas podem ser criadas para as semanas em que o horário de <br /> reserva recorrente pretendido pelo paciente estão indisponíveis.
            </Typography>
          </>
          )
      }
    </S.Container>
  )
}